<div>
  <app-back-button></app-back-button>

  <div class="details-container" *ngIf="wellRequest$ | async as wellRequest">
    <app-well-details-header style="width:950px;"  [wellRequest]="wellRequest"></app-well-details-header>

    <div>
      <app-well-details-admin></app-well-details-admin>
      <mat-divider></mat-divider>
    </div>

    <!-- selectable admin
    <form [formGroup]="form">
      <div>
        <div>
          <div style="margin:0px 0px -28px 50px;">
            <mat-icon matTooltip="A group name selection is needed to enable admin list" style="font-size: 21px; color: blue">info</mat-icon>
          </div>
          <app-chip #chipComponent label="Admin"
            placeholder="Enter admin..."
            [dataSource]="filteredAdmins"
            [selectedSourceItems]="selectedAdmins"
            [isRemovableFunc]="isAdminRemovable"
            [count]=5
            formControlName="admin"
            app-autocomplete-validator
            required
            (selectedItemsEvent)="onAdminSelected($event)"
            (removeEvent)="onAdminRemoved($event)">
          </app-chip>
        </div>
        <mat-divider></mat-divider>
      </div>
    </form>
    -->

    <div class="details-info-container">
      <app-well-details-info [wellRequest]="wellRequest"></app-well-details-info>
    </div>
    <app-well-details-comments></app-well-details-comments>
  </div>
  
  <div class="form-buttons">
    <button mat-raised-button type="button" color="primary" class="submit-button accent-button" (click)="editRequest()">Edit</button>
  </div>
</div>
